import React, { useState, useRef, useReducer, useEffect } from 'react';
import {
  Form,
  message,
  Modal,
  Row,
  Table,
  Tabs,
  InputNumber,
  Tooltip,
} from 'antd';
import {
  Checkbox,
  InfoBox,
  Layout,
  MobileTabBar,
  Button,
  Input,
  SelectFile,
  Footer,
} from 'components';
import classNames from 'classnames';

import ExportFileIcon from 'assests/icons/export-file.icon';

import 'components/BlackList/black-list.less';
import 'components/GuildePage/guide-page.less';
import 'components/Checkbox/checkbox.less';
import { CSVLink } from 'react-csv';
import {
  getBlackListOptIn,
  getBlackListOptOut,
  addOptOut,
  addOptIn,
  addNumbersToBlacklist,
} from 'services/blacklist.service';
import { customMessages, customValidators } from 'utils';
import CheckBorderBoldIcon from 'assests/icons/check-border-bold.icon';
import DownChevronIcon from 'assests/icons/down-chevron.icon';
import ImportExcelIcon from 'assests/icons/import-excel.icon';
import UploadIcon from 'assests/icons/upload.icon';
import AddNewModal from './partials/add-new-modal';
import AddFileModal from './partials/add-file-modal';
import DeleteIcon from 'assests/icons/delete.icon';

const OptOutTable = () => {
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  const exportRefLink = useRef(null);
  const [selectedRow, setSelectedRow] = useState([]);
  const [arrayList, setArrayList] = useState([]);
  const [importFileModal, setImportFileModal] = useState(false);
  const [addRowModal, setAddRowModal] = useState(false);
  const [removeFromBlackListModal, setRemoveFromBlackListModal] =
    useState(false);

  const [form] = Form.useForm();

  function fetchData() {
    getBlackListOptOut()
      .then((result) => {
        setArrayList(result.consentStatusOutList);
      })
      .catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }

  function onAddOptIn(data) {
    addOptIn({ ids: data })
      .then((result) => {
        fetchData();
      })
      .catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
    setSelectedRow([]);
  }

  function onExport() {
    exportRefLink.current.link.click();
  }

  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    {
      title: '',
      dataIndex: 'check',
      children: [
        {
          title: () => (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  arrayList.map((item) => {
                    item.checked = true;
                    return item;
                  });
                  setSelectedRow(arrayList);
                } else {
                  arrayList.map((item) => {
                    item.checked = false;
                    return item;
                  });
                  setSelectedRow([]);
                }
                forceUpdate();
              }}
            />
          ),
          dataIndex: 'check',
          render: (a, selectedRows, c) => (
            <>
              <Checkbox
                checked={selectedRows.checked}
                onChange={(e) => {
                  selectedRows.checked = e.target.checked;
                  if (selectedRows.checked === true) {
                    setSelectedRow((prevArray) => [...prevArray, selectedRows]);
                  } else {
                    setSelectedRow(
                      selectedRow.filter((e) => e !== selectedRows)
                    );
                  }
                  forceUpdate();
                }}
              />
            </>
          ),
        },
      ],
    },
    {
      title: 'Telefon No',
      children: [
        {
          title: 'Tümünü Seç',
          dataIndex: 'msisdn',
        },
      ],
    },
    {
      title: 'Eklenme Tarihi',
      children: [
        {
          title: () => (
            <div className="table-group-actions">
              {selectedRow.length > 0 ? (
                <>
                  <span>{selectedRow.length} Kişi Seçildi</span>
                  <div className="group-actions">
                    <button
                      onClick={() => {
                        setRemoveFromBlackListModal(true);
                      }}
                      type="button"
                    >
                     <DeleteIcon />
                      <span>Kara Listeden Çıkar</span>
                    </button>
                  </div>
                </>
              ) : null}
            </div>
          ),
          dataIndex: 'lastOptoutDate',
          render: (text) => (
            <>
              <span>{text}</span>
              {/* <div className="row-edit">
              <button onClick={ () => {setRemoveFromBlackListModal(true)} } type="button"><CheckBorderBoldIcon /></button>
            </div> */}
            </>
          ),
        },
      ],
    },
  ];

  const headers = [
    { label: 'Telefon Numarası', key: 'msisdn' },
    { label: 'Kara Listeye Eklenme Tarihi', key: 'lastOptoutDate' },
  ];

  return (
    <div className="group-members">
      <div className="group-members__header">
        <strong className="group-members__title">
          Kara Listedeki Kullanıcılar
        </strong>
        <div className="group-actions">
          <button
            onClick={() => {
              onExport();
            }}
            type="button">
            <ExportFileIcon />
            <span>Dışa aktar</span>
          </button>
          <CSVLink
            data={arrayList}
            headers={headers}
            ref={exportRefLink}
            filename={'karaliste.xls'}
            separator={';'}
            target="_blank"
          >
          </CSVLink>
          <AddNewModal onSuccess={(e) => fetchData()}></AddNewModal>
          <AddFileModal onSuccess={(e) => fetchData()}></AddFileModal>
        </div>
      </div>

      <Table
        rowKey="msisdn"
        columns={columns}
        scroll={{ y: 610 }}
        dataSource={arrayList}
        className="table--guide table--black-list"
        pagination={{ total: arrayList.length, position: ['bottomCenter'] }}
      />

      <Modal
        title="Kara Listeden Çıkar"
        visible={removeFromBlackListModal}
        onCancel={() => setRemoveFromBlackListModal(false)}
        footer={null}
      >
        <p>
          Seçtiğiniz {selectedRow.length} kayıt kara listeden çıkarılacaktır. Bu
          kayıtlara “Kara Listeden Çıkanlar” bölümünden ulaşabilirsiniz.
        </p>
        <div className="modal-action">
          <Button
            shape="round"
            type="ghost"
            onClick={() => setRemoveFromBlackListModal(false)}
          >
            Vazgeç
          </Button>
          <Button
            key="confirm"
            type="primary"
            onClick={() => {
              onAddOptIn(selectedRow.map((item) => item.msisdn));
              setRemoveFromBlackListModal(false);
            }}
          >
            Çıkar
          </Button>
        </div>
      </Modal>
    </div>
  );
};
export default OptOutTable;
